import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconSend = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-send" data-icon="icon-send" aria-hidden="true" {...props} ref={ref}><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>);
});

IconSend.displayName = 'IconSend';
